/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RunScopeDto { 
    instanceId?: string;
    parentInstanceId?: string;
    parentNodeId?: string;
    definitionId?: string;
    label?: string;
    depth?: number;
    status?: RunScopeDto.StatusEnum;
    fanoutIndex?: number;
    ruleId?: string;
    ruleName?: string;
    fileId?: string;
    fileName?: string;
    startedAt?: Date;
    completedAt?: Date;
}
export namespace RunScopeDto {
    export type StatusEnum = 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED' | 'PAUSED' | 'CANCELLED';
    export const StatusEnum = {
        PENDING: 'PENDING' as StatusEnum,
        RUNNING: 'RUNNING' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        PAUSED: 'PAUSED' as StatusEnum,
        CANCELLED: 'CANCELLED' as StatusEnum
    };
}